import React, { useState, useEffect, useRef } from 'react';
import { Home, Briefcase, MessageCircle, Star, CreditCard, Bell, Heart, Search, Menu, X, ChevronDown, Settings, LogOut, User, HelpCircle, Gem, BookOpen } from 'lucide-react';
import styles from './LandingPageNavBar.module.css';

const LandingPageNavBar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  const navItems = [
    { id: 'home-owner', label: 'Why BuildStart', href: '#' },
    { id: 'home-owner', label: 'How it works', href: '#' },
    { id: 'directory', label: 'Directory', href: '#' },
    { id: 'resources', label: 'Resources', href: '#' },
    { id: 'about-us', label: 'About Us', href: '#' }
  ];

  const handleNavClick = (item) => {
    setIsMobileMenuOpen(false);
    window.location.href = item.href;
  };

  return (
    <>
      <nav className={`${styles.modern_navbar} ${isScrolled ? styles.modern_navbar_scrolled : ''}`}>
        <div className={styles.modern_navbar_container}>
          <div className={styles.modern_navbar_logo}>
            <div className={styles.logo_icon}>
              <div className={styles.logo_house_icon}>🏠</div>
            </div>
            <div className={styles.logo_text}>
              <span className={styles.logo_brand}>BuildStart</span>
            </div>
          </div>

          <div className={styles.modern_navbar_nav}>
            {navItems.map((item) => {
              return (
                <button
                  key={item.id}
                  onClick={() => handleNavClick(item)}
                  className={styles.nav_item}
                >
                  <div className={styles.nav_item_content}>
                    <span className={styles.nav_item_label}>{item.label}</span>
                  </div>
                  <div className={styles.nav_item_indicator}></div>
                </button>
              );
            })}
          </div>

          <div className={styles.modern_navbar_right}>
            <button className={styles.action_button}>Get Quotes</button>
            <button className={styles.action_button_secondary}>For Businesses</button>
            <button className={styles.login_button}>Login</button>
            <button
              className={styles.mobile_menu_button}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X style={{ width: '1.5rem', height: '1.5rem' }} /> : <Menu style={{ width: '1.5rem', height: '1.5rem' }} />}
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className={styles.mobile_nav_overlay}>
            <div className={styles.mobile_nav_menu}>
              {navItems.map((item) => {
                return (
                  <button
                    key={item.id}
                    onClick={() => handleNavClick(item)}
                    className={styles.mobile_nav_item}
                  >
                    <span className={styles.mobile_nav_item_label}>{item.label}</span>
                  </button>
                );
              })}
               <div className={styles.mobile_action_buttons}>
                <button className={styles.action_button}>Get Quotes</button>
                <button className={styles.action_button_secondary}>For Businesses</button>
                <button className={styles.login_button}>Login</button>
              </div>
            </div>
          </div>
        )}
      </nav>

      {isMobileMenuOpen && (
        <div 
          className={styles.mobile_nav_backdrop}
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </>
  );
};

export default LandingPageNavBar;
